module.exports = __webpack_public_path__ + "static/media/2.เอกสารแผนที่บ้านและสถานที่ประกอบอาชีพ.44b5591b.pdf";